import type { SVGProps } from 'react';

const SvgMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={20}
    viewBox='0 0 20 20'
    width={20}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M10 2.375a7.625 7.625 0 1 0 0 15.25 7.625 7.625 0 0 0 0-15.25M3.625 10a6.375 6.375 0 1 1 12.75 0 6.375 6.375 0 0 1-12.75 0m4.76 2.606a.625.625 0 1 0 0 1.25h3.23a.625.625 0 0 0 0-1.25h-.99V9.462A.625.625 0 0 0 10 8.837H8.923a.625.625 0 1 0 0 1.25h.452v2.519zM10 7.79A.895.895 0 1 0 10 6a.895.895 0 0 0 0 1.79'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgMark;
